import http from "../../helpers/http";
import * as helpers from "../../helpers/api";
import { toast } from "react-toastify";
import { TOAST_SETTINGS } from "../../utils/siteSettings";
import Text from "../../components/common/Text";

import {
    FETCH_USER_PROPERTIES_CONTENT,
    FETCH_USER_PROPERTIES_CONTENT_SUCCESS,
    FETCH_USER_PROPERTIES_CONTENT_FAILED,
    USER_PROPERTIES_DELETE__MESSAGE,
    USER_PROPERTIES_DELETE_MESSAGE_SUCCESS,
    USER_PROPERTIES_DELETE__MESSAGE_FAILED,
    USER_PROPERTIES_CANCEL__MESSAGE,
    USER_PROPERTIES_CANCEL__MESSAGE_FAILED,
    USER_PROPERTIES_CANCEL_MESSAGE_SUCCESS
} from "./actionTypes";

export const fetchUserProperties = () => (dispatch) => {
    dispatch({
        type: FETCH_USER_PROPERTIES_CONTENT,
        payload: null
    });
    http
        .get("user-properties")
        .then(({ data }) => {
            dispatch({
                type: FETCH_USER_PROPERTIES_CONTENT_SUCCESS,
                payload: data
            });
        })
        .catch((error) => {
            dispatch({
                type: FETCH_USER_PROPERTIES_CONTENT_FAILED,
                payload: error
            });
        });
};


export const deleteUserProperty = (formData) => (dispatch) => {
    dispatch({
        type: USER_PROPERTIES_DELETE__MESSAGE,
        payload: null
    });
    http
        .post('delete-user-property/' + formData, helpers.doObjToFormData(formData))
        .then(({ data }) => {
            if (data.status) {
                toast.success(
                    `${data.msg}`,
                    TOAST_SETTINGS
                );
                setTimeout(() => {
                    window.location.replace("/properties");
                }, 2000);
                dispatch({
                    type: USER_PROPERTIES_DELETE_MESSAGE_SUCCESS,
                    payload: data
                });
            } else {
                toast.error(
                    <Text string={data.msg} parse={true} />,
                    TOAST_SETTINGS
                );
                dispatch({
                    type: USER_PROPERTIES_DELETE__MESSAGE_FAILED,
                    payload: null
                });
            }
        })
        .catch((error) => {
            dispatch({
                type: USER_PROPERTIES_DELETE__MESSAGE_FAILED,
                payload: error
            });
        });
};
export const cancelPropertyRequest = (request_id) => (dispatch) => {
    dispatch({
        type: USER_PROPERTIES_CANCEL__MESSAGE,
        payload: null
    });
    http
        .post('cancel-property-request/' + request_id, helpers.doObjToFormData(request_id))
        .then(({ data }) => {
            if (data.status) {
                toast.success(
                    `${data.msg}`,
                    TOAST_SETTINGS
                );
                setTimeout(() => {
                    window.location.replace("/properties");
                }, 2000);
                dispatch({
                    type: USER_PROPERTIES_CANCEL_MESSAGE_SUCCESS,
                    payload: data
                });
            } else {
                toast.error(
                    <Text string={data.msg} parse={true} />,
                    TOAST_SETTINGS
                );
                dispatch({
                    type: USER_PROPERTIES_CANCEL__MESSAGE_FAILED,
                    payload: null
                });
            }
        })
        .catch((error) => {
            dispatch({
                type: USER_PROPERTIES_CANCEL__MESSAGE_FAILED,
                payload: error
            });
        });
};